import { FC } from "react"
import { Icon, IconColor } from "@/components/shared/Icon"

interface ActionButtonsProps {
   isFormValid: boolean
   onSave: () => void
   onCancel: () => void
}

const ActionButtons: FC<ActionButtonsProps> = ({
   isFormValid,
   onSave,
   onCancel,
}) => (
   <span className="customers-facilities-table__actions">
      <Icon
         name="cross"
         size="16px"
         color={IconColor.HONOLULU_BLUE}
         onClick={onCancel}
      />
      <Icon
         disabled={!isFormValid}
         name="save"
         size="16px"
         color={IconColor.HONOLULU_BLUE}
         onClick={onSave}
      />
   </span>
)

export default ActionButtons
